import { ConstrainedItem, ConstrainedObject, ConstraintScope } from '@Models';
import { findConstrainedParentByScope } from './find-constrained-parent-by-scope';

export const findChildElements = (
  elements: ConstrainedObject[],
  parent: ConstrainedItem,
): ConstrainedItem[] => {
  const result: ConstrainedItem[] = [];

  for (const element of elements) {
    if (
      element.parent.type === parent.type &&
      element.parent.id === parent.id
    ) {
      result.push({
        id: element.id,
        type: element.type,
        name: element.name,
      } satisfies ConstrainedItem as ConstrainedItem);
      result.push(...findChildElements(elements, element));
    }
  }

  return result;
};

export const allConstrainableChildByScope = (
  elements: ConstrainedObject[],
  item: ConstrainedObject,
  scope: ConstraintScope,
): ConstrainedItem[] => {
  const parent: ConstrainedItem = findConstrainedParentByScope(
    elements,
    item,
    scope,
  );

  const results = findChildElements(elements, parent);

  if (scope !== ConstraintScope.Parent) {
    results.push(parent);
  }

  return results;
};
